import { useEffect, useRef, useState } from "react";
import { AlertCircle, Search, User, UserPlus } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import {
  addShiftAssignment,
  getShiftAssignmentById,
  masterShiftSearch,
  searchAssignmentData,
  updateShiftAssignment,
} from "../../api/shiftAssignmentApi";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Tab from "../../components/Tab";
import Button from "../../components/input/Button";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import SideDrawer from "../../components/input/SideDrawer";
import {
  ActiveCellStyle,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import ShiftAssignmentForm from "../../components/transaction/CallCenter/ShiftAssignmentForm";
import ShiftAssignmentStakeholders from "../../components/transaction/CallCenter/ShiftAssignmentStakeholders";
import ShiftAssignmentUsers from "../../components/transaction/CallCenter/ShiftAssignmentUsers";
import {
  shiftActionAssignValidation,
  shiftAssignValidation,
} from "../../components/validations/ShiftAssignmentCreation";
import { FORMS, MODULES } from "../../const";
import useFirstAndLastAuthorizedTab from "../../hooks/useFirstAndLastAuthorizedTab";
import useNextAndPreviousAuthority from "../../hooks/useNextAndPreviousAuthority";
import { errorActions } from "../../store/error-slice";
import Modal from "../../components/Modal";

const ShiftAssignment = () => {
  const { firstViableTab, lastViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Transaction,
    section: FORMS.CALL_CENTER_SHIFT_ASSIGNMENT,
  });
  const dispatch = useDispatch();
  const [tab, setTab] = useState(1);
  const [drawerTab, setDrawerTab] = useState(firstViableTab);
  const { next, prev } = useNextAndPreviousAuthority({
    sectionKey: "shiftAssign",
    minTab: 1,
    maxTab: 3,
    module: MODULES.Transaction,
    section: FORMS.CALL_CENTER_SHIFT_ASSIGNMENT,
    currentTab: drawerTab,
    authenticated: true,
  });
  const user = useSelector((state) => state.user);
  const errorState = useSelector((state) => state.error.shiftAssignmentErrors);

  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [resetVisible, setResetVisible] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [editShiftAssign, setEditShiftAssign] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [searchFetchLoading, setSearchFetchLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [searchSubmitLoading, setSearchSubmitLoading] = useState(false);
  const [searchRes, setSearchRes] = useState(false);

  // dropdown
  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [yesNoOptions, setYesNoOptions] = useState([]);
  const [actionStatusOptions, setActionStatusOptions] = useState([]);

  //tab ref
  const userRef = useRef();
  const stkRef = useRef();
  const assignmentRef = useRef();

  // search ref
  const codeRef = useRef(null);
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  //search state
  const [status, setStatus] = useState(null);
  const [active, setActive] = useState(null);
  const [shift, setShift] = useState(null);
  const [actionStatus, setActionStatus] = useState(null);

  //auto group load
  const [userGroupLoad, setUserGroupLoad] = useState([]);
  const [stkGroupLoad, setStkGroupLoad] = useState([]);
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [pendingSubmitEvent, setPendingSubmitEvent] = useState(null);
  const deleteWarningRef = useRef();

  const [searchFieldReset, setSearchFieldReset] = useState(false);

  const handleDrawerOpen = () => {
    setEditMode(false);
    setDrawerTab(firstViableTab);
    setEditShiftAssign(null);
    setIsDrawerOpen(true);
    dispatch(errorActions.clearShiftAssignmentError());
  };

  useEffect(() => {
    (async () => {
      //new

      const { active: activeData, status: statusData } =
        await getBulkDropdownData([{ key: "active" }, { key: "status" }]);

      setActiveOptions(activeData);
      setStatusOptions(statusData);

      const actionStatusData = await getOtherRefSearchDropdown({
        type: "shift_action",
        param1: "",
      });
      const updatedActionStatusData = actionStatusData.map(
        (actionStatusData) => {
          return {
            ...actionStatusData,
            text: actionStatusData.title,
          };
        },
      );
      setActionStatusOptions(updatedActionStatusData);
    })();
  }, []);

  const reset = () => {
    assignmentRef.current.resetForm();
    userRef.current.resetForm();
    stkRef.current.resetForm();
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
    setStkGroupLoad([]);
    setUserGroupLoad([]);
    dispatch(errorActions.clearShiftAssignmentError());
  };
  const handleReset = (e) => {
    e.preventDefault();
    if (tab === 1) {
      setSearchClicked(false);
      setResetVisible(false);
    }
  };
  const nextButtonHandler = () => {
    switch (drawerTab) {
      case 1: {
        const shiftErrors = shiftAssignValidation(
          assignmentRef.current.getAssignmentData(),
        );
        const shiftActionErrors = shiftActionAssignValidation(
          assignmentRef.current.getActionsData(),
        );

        if (
          Object.keys(shiftErrors).length > 0 ||
          Object.keys(shiftActionErrors).length > 0
        ) {
          dispatch(
            errorActions.addShiftAssignmentErrorObject({
              form: "shiftAssignmentErrors",
              errors: shiftErrors,
            }),
          );
          dispatch(
            errorActions.addShiftAssignmentErrorObject({
              form: "shiftAssignmentActionErrors",
              errors: shiftActionErrors,
            }),
          );
          setIsSubmitLoading(false);
          toast.error("There was an error adding Shift", {
            autoClose: 5000,
            containerId: "Main",
          });
          return;
        } else {
          dispatch(errorActions.clearBlackListError());
        }
        break;
      }
      default:
    }
    setDrawerTab(next());
  };
  const handleSubmit = async (e, bypassDeleteCheck = false) => {
    e.preventDefault();
    if (!bypassDeleteCheck && assignmentRef.current.isDeletedActive()) {
      setPendingSubmitEvent(e);
      setShowDeleteWarning(true);
      deleteWarningRef.current?.showModal();
      return;
    }
    setIsSubmitLoading(true);
    dispatch(errorActions.clearShiftAssignmentError());

    const shiftErrors = shiftAssignValidation(
      assignmentRef.current.getAssignmentData(),
    );
    const shiftActionErrors = shiftActionAssignValidation(
      assignmentRef.current.getActionsData(),
    );

    if (
      Object.keys(shiftErrors).length > 0 ||
      Object.keys(shiftActionErrors).length > 0
    ) {
      dispatch(
        errorActions.validateShiftAssignment({
          shiftAssignmentData: assignmentRef.current.getAssignmentData(),
        }),
      );
      dispatch(
        errorActions.addShiftAssignmentErrorObject({
          form: "shiftAssignmentActionErrors",
          errors: shiftActionErrors,
        }),
      );
      setIsSubmitLoading(false);
      toast.error("There was an error adding Shift", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    } else {
      if (editMode) {
        const stkData = stkRef.current.getData();
        const invalidStk = stkRef.current.validateForm();
        if (invalidStk) {
          dispatch(
            errorActions.addShiftAssignmentError({
              form: "submitErrors",
              key: "noStakeholderError",
              value: "Should have at least one stakeholder",
            }),
          );
          // setIsStkTypeError(true);
          toast.error("Should have at least one stakeholder", {
            autoClose: 5000,
            containerId: "Main",
          });
          setIsSubmitLoading(false);
          return;
        } else {
          // setIsStkTypeError(false);
          delete stkData.unmodified;
        }

        const userData = userRef.current.getData();
        const invalidUser = userRef.current.validateForm();
        if (invalidUser) {
          dispatch(
            errorActions.addShiftAssignmentError({
              form: "submitErrors",
              key: "noUserError",
              value: "Should have at least one user",
            }),
          );
          // setIsStkTypeError(true);
          toast.error("Should have at least one User", {
            autoClose: 5000,
            containerId: "Main",
          });
          setIsSubmitLoading(false);
          return;
        } else {
          // setIsStkTypeError(false);
          delete userData.unmodified;
        }

        try {
          const response = await updateShiftAssignment({
            shiftAssignmentUpdateRequest:
              assignmentRef.current.getAssignmentData(),
            ShiftActionAssignmentUpdateRequest:
              assignmentRef.current.getActionsData(),
            shiftUserAssignmentUpdateRequest: userRef.current.getData(),
            shiftStakeholderAssignmentUpdateRequest: stkRef.current.getData(),
            author: user.username,
          });
          toast.success("Shift Assignment updated successfully!", {
            autoClose: 5000,
            containerId: "Main",
          });
          reset();
        } catch (e) {
          setIsSubmitLoading(false);
        }
      } else {
        const stkData = stkRef.current.getData();
        const invalidStk = stkRef.current.validateForm();
        if (invalidStk) {
          dispatch(
            errorActions.addShiftAssignmentError({
              form: "submitErrors",
              key: "noStakeholderError",
              value: "Should have at least one stakeholder",
            }),
          );
          // setIsStkTypeError(true);
          toast.error("Should have at least one stakeholder", {
            autoClose: 5000,
            containerId: "Main",
          });
          setIsSubmitLoading(false);
          return;
        } else {
          // setIsStkTypeError(false);
          delete stkData.unmodified;
        }

        const userData = userRef.current.getData();
        const invalidUser = userRef.current.validateForm();
        if (invalidUser) {
          dispatch(
            errorActions.addShiftAssignmentError({
              form: "submitErrors",
              key: "noUserError",
              value: "Should have at least one user",
            }),
          );
          // setIsStkTypeError(true);
          toast.error("Should have at least one User", {
            autoClose: 5000,
            containerId: "Main",
          });
          setIsSubmitLoading(false);
          return;
        } else {
          // setIsStkTypeError(false);
          delete userData.unmodified;
        }
        try {
          const response = await addShiftAssignment({
            shiftAssignmentRequest: assignmentRef.current.getAssignmentData(),
            shiftActionRequest: assignmentRef.current.getActionsData(),
            shiftUserAssignmentRequest: userRef.current.getData(),
            shiftStakeholderAssignmentRequest: stkRef.current.getData(),
            author: user.username,
          });
          toast.success("Shift Assignment added successfully!", {
            autoClose: 5000,
            containerId: "Main",
          });
          reset();
        } catch (e) {
          setIsSubmitLoading(false);
        }
      }
    }
    handleDrawerClose();
    setIsSubmitLoading(false);
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    if (tab === 1) {
      setActiveAccordion1(false);
      setResetVisible(true);
      setSearchClicked(true);
      setSearchSubmitLoading(true);
    }
    const response = await searchAssignmentData({
      code: codeRef.current.value,
      masterShift: shift,
      shiftAction: actionStatus,
      from: fromDateRef.current.value,
      to: toDateRef.current.value,
      status: status,
      active: active,
    });
    setSearchRes(response);
    setSearchSubmitLoading(false);
  };

  const handleSearchReset = (e) => {
    e.preventDefault();

    setStatus(null);
    setActive(null);
    setActionStatus(null);
    setShift(null);
    codeRef.current.reset();
    fromDateRef.current.reset();
    toDateRef.current.reset();
    setSearchFieldReset(true);
  };

  const deleteWarningModal = (
    <div style={{ padding: "20px" }}>
      <h3 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <AlertCircle color="red" size="25" />
        <p>Warning</p>
      </h3>
      <p>Active is set to Deleted. Are you sure you want to proceed?</p>
      <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
        <Button
          label="Cancel"
          onClick={() => {
            deleteWarningRef.current?.close();
            setShowDeleteWarning(false);
            setPendingSubmitEvent(null);
          }}
        />
        <Button
          label="Proceed"
          className="ui red button"
          onClick={() => {
            deleteWarningRef.current?.close();
            setShowDeleteWarning(false);
            handleSubmit(pendingSubmitEvent, true);
            setPendingSubmitEvent(null);
          }}
        />
      </div>
    </div>
  );
  return (
    <>
      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="ui tabular menu attached">
          <div
            className={`item ${tab === 1 ? "active" : ""}`}
            onClick={() => {
              setTab(1);
            }}
          >
            <span>
              <UserPlus size={15} style={{ marginRight: "5px" }} />
            </span>
            Shift Assignment Search
          </div>
        </div>
        <Button
          template="drawerOpen"
          disabled={firstViableTab === -1}
          onClick={handleDrawerOpen}
          authenticated={true}
          form={FORMS.CALL_CENTER_SHIFT_ASSIGNMENT.SFH.form}
          module={MODULES.Transaction}
          editMode={false}
        />
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => setActiveAccordion1(!activeAccordion1)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>

              <i
                className="refresh icon primary button"
                style={{
                  display: `${resetVisible ? "flex" : "none"}`,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  handleReset(e);
                }}
              ></i>
            </div>
          </div>
          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <h4 className="ui dividing header"></h4>
                <div className="four fields">
                  <Input
                    label="Shift Code"
                    placeholder="Shift Code"
                    name="shiftCode"
                    ref={codeRef}
                  />
                  <SearchDropdown
                    key={1}
                    field="sfh_shift"
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    onResultSelect={(data) => {
                      setShift(data);
                    }}
                    clearable={true}
                    onClear={() => {
                      setShift(null);
                    }}
                    api={masterShiftSearch}
                    label="Master Shift"
                  />
                  {/*<Dropdown*/}
                  {/*    search={true}*/}
                  {/*    options={actionStatusOptions}*/}
                  {/*    placeholder="Actions"*/}
                  {/*    label="Actions"*/}
                  {/*    field="sha_status"*/}
                  {/*    value={actionStatus}*/}
                  {/*    onChange={(e, data) => {*/}

                  {/*        setActionStatus(data.value);*/}
                  {/*    }}*/}

                  {/*/>*/}
                  <Input
                    label="from Date"
                    type="date"
                    name="empExpiaryDate"
                    placeholder="To Date"
                    ref={fromDateRef}
                  />
                  <Input
                    label="To Date"
                    type="date"
                    name="empExpiaryDate"
                    placeholder="To Date"
                    ref={toDateRef}
                  />
                </div>
                <div className="four fields">
                  <Dropdown
                    label="Status"
                    options={statusOptions}
                    placeholder="Status"
                    style={{ height: "20px" }}
                    value={status}
                    onChange={(e, data) => {
                      setStatus(data.value);
                    }}
                  />
                  <Dropdown
                    label="Active"
                    options={activeOptions}
                    placeholder="Active"
                    style={{ height: "20px" }}
                    value={active}
                    onChange={(e, data) => {
                      setActive(data.value);
                    }}
                  />
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={(e) => {
                        handleSearchSubmit(e);
                      }}
                    />
                    <Button
                      template="searchReset"
                      onClick={(e) => {
                        handleSearchReset(e);
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {searchClicked && (
          <>
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={searchFetchLoading}
                content={searchRes}
                cellSizeStrategy="fitCellContents"
                fitContentCellls={["blkAccident"]}
                config={[
                  {
                    headerName: "Id",
                    field: "id",
                    sort: "desc",
                    hide: true,
                  },
                  {
                    headerName: "Code",
                    field: "code",
                  },
                  {
                    headerName: "Shift Name",
                    field: "name_",
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "active",
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  setSearchFetchLoading(true);
                  const response = await getShiftAssignmentById(props.data.id);
                  setEditShiftAssign(response);
                  setEditMode(true);
                  setIsDrawerOpen(true);
                  dispatch(errorActions.clearShiftAssignmentError());
                  setSearchFetchLoading(false);
                  setDrawerTab(firstViableTab);
                }}
              />
            )}
          </>
        )}
      </div>

      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          editMode ? (
            <div
              className="blacklist-code-header"
              style={{ padding: "10px 16px", borderBottom: "1px solid #ccc" }}
            >
              <h3>
                Shift Code: {editShiftAssign?.shiftAssignmentResponse?.sfhCode}
              </h3>
            </div>
          ) : null
        }
        body={
          <form className="drawer-content" onSubmit={handleSubmit}>
            <div className={"blacklist-card-container"}>
              <div style={{ width: "60vw", boxShadow: "none" }}>
                <div className="ui top attached tabular menu">
                  <Tab
                    Icon={UserPlus}
                    onClick={() => {
                      setDrawerTab(1);
                    }}
                    active={drawerTab === 1}
                    errors={
                      Object.keys(errorState.shiftAssignmentErrors).length !== 0
                    }
                    label="Shift Assignment"
                    authenticated={true}
                    form={FORMS.CALL_CENTER_SHIFT_ASSIGNMENT.SHIFT_ASSIGN.form}
                    resizeForSmallerScreens={true}
                    module={MODULES.Transaction}
                    showMandatory={true}
                    isMandatory={true}
                  />
                  <Tab
                    Icon={User}
                    onClick={() => {
                      setDrawerTab(2);
                    }}
                    active={drawerTab === 2}
                    label="Stakeholders"
                    authenticated={true}
                    module={MODULES.Transaction}
                    resizeForSmallerScreens={true}
                    form={FORMS.CALL_CENTER_SHIFT_ASSIGNMENT.SHIFT_STK.form}
                  />
                  <Tab
                    Icon={User}
                    onClick={() => {
                      setDrawerTab(3);
                    }}
                    active={drawerTab === 3}
                    label="Users"
                    authenticated={true}
                    module={MODULES.Transaction}
                    resizeForSmallerScreens={true}
                    form={FORMS.CALL_CENTER_SHIFT_ASSIGNMENT.SHIFT_USER.form}
                  />
                </div>

                <div
                  className="ui bottom attached active tab segment"
                  style={{ display: drawerTab === 1 ? "block" : "none" }}
                >
                  <ShiftAssignmentForm
                    editMode={editMode}
                    errors={errorState}
                    isLoading={isLoading}
                    ref={assignmentRef}
                    setUserGroupLoad={setUserGroupLoad}
                    setStkGroupLoad={setStkGroupLoad}
                    currentValues={
                      editMode && editShiftAssign != null
                        ? editShiftAssign.shiftAssignmentResponse
                        : null
                    }
                    currentActionValues={
                      editMode && editShiftAssign != null
                        ? editShiftAssign.shiftAssignmentActionsResponses
                        : null
                    }
                  />
                </div>

                <div
                  className="ui bottom attached active tab segment"
                  style={{ display: drawerTab === 2 ? "block" : "none" }}
                >
                  <ShiftAssignmentStakeholders
                    editMode={editMode}
                    errors={errorState.shiftStakeholderErrors}
                    isLoading={isLoading}
                    ref={stkRef}
                    stkGroupLoad={stkGroupLoad}
                    currentValues={
                      editMode && editShiftAssign != null
                        ? editShiftAssign.shiftStakeholderAssignmentResponse
                        : null
                    }
                  />
                </div>

                <div
                  className="ui bottom attached active tab segment"
                  style={{ display: drawerTab === 3 ? "block" : "none" }}
                >
                  <ShiftAssignmentUsers
                    editMode={editMode}
                    errors={errorState.shiftUserErrors}
                    isLoading={isLoading}
                    ref={userRef}
                    userGroupLoad={userGroupLoad}
                    currentValues={
                      editMode && editShiftAssign != null
                        ? editShiftAssign.shiftUserAssignmentResponse
                        : null
                    }
                  />
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {drawerTab > firstViableTab && (
                      <Button
                        template="back"
                        tab={drawerTab - 1}
                        module={MODULES.Transaction}
                        section={FORMS.CALL_CENTER_SHIFT_ASSIGNMENT}
                        authenticated={true}
                        onClick={() => setDrawerTab(prev())}
                      />
                    )}
                    {drawerTab < lastViableTab && (
                      <Button
                        template="next"
                        tab={drawerTab + 1}
                        module={MODULES.Transaction}
                        section={FORMS.CALL_CENTER_SHIFT_ASSIGNMENT}
                        authenticated={true}
                        onClick={nextButtonHandler}
                      />
                    )}
                    {editMode ? (
                      <Button
                        type="submit"
                        template="create"
                        isLoading={isSubmitLoading}
                        create={!editMode}
                        form={FORMS.CALL_CENTER_SHIFT_ASSIGNMENT.SFH.form}
                        module={MODULES.Transaction}
                        section={FORMS.CALL_CENTER_SHIFT_ASSIGNMENT}
                        authenticated={true}
                        editMode={editMode}
                      />
                    ) : drawerTab === lastViableTab && !isLoading ? (
                      <Button
                        type="submit"
                        template="create"
                        isLoading={isSubmitLoading}
                        create={!editMode}
                        form={FORMS.CALL_CENTER_SHIFT_ASSIGNMENT.SFH.form}
                        module={MODULES.Transaction}
                        section={FORMS.CALL_CENTER_SHIFT_ASSIGNMENT}
                        authenticated={true}
                        editMode={editMode}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {/*{submitted && errorState.hasErrors && (*/}
                {/*    <UIMessage type="negative" width="100%" centered={false}>*/}
                {/*        <div className="content">*/}
                {/*            <div className="header">*/}
                {/*                There was some errors with your submission*/}
                {/*            </div>*/}
                {/*            {Object.keys(errorState.blackListErrors).length > 0 && (*/}
                {/*                <p>*/}
                {/*                    <div className="header">Employee</div>*/}
                {/*                    <div className="content">*/}
                {/*                        <ul>*/}
                {/*                            {Object.entries(errorState.blackListErrors).map(*/}
                {/*                                ([_, value]) => (*/}
                {/*                                    <li>{value}</li>*/}
                {/*                                ),*/}
                {/*                            )}*/}
                {/*                        </ul>*/}
                {/*                    </div>*/}
                {/*                </p>*/}
                {/*            )}*/}
                {/*        </div>*/}
                {/*    </UIMessage>*/}
                {/*)}*/}
              </div>
            </div>
          </form>
        }
        style={{ width: "60vw", boxShadow: "none" }}
      />
      <Modal ref={deleteWarningRef} closeButton={false} minWidth={"300px"}>
        {showDeleteWarning && deleteWarningModal}
      </Modal>
    </>
  );
};

export default ShiftAssignment;
